import {
  DELETE,
  GET,
  POST,
  UPLOAD_FILE,
} from "../../apiController";

const endpoint = "/admin/settings/payment";

// ------------------- setting payment

// Get payments with pagination, search and status filter
export const getPayments = (data) => {
  return POST(endpoint, data);
};

// Get payment details by ID
export const getPaymentById = (id) => {
  return GET(endpoint + `/${id}`);
};

// ------------------------------------------------------- certificates

export const getOrgCertificate = (data) => {
  return GET(
    endpoint + `/get_certificate?page=${data.page}&limit=${data.limit}`
  );
};

// create a API endpoint for creating certificates
export const createCertificate = (data) => {
  const url = endpoint + `/create_certificate`;
  return UPLOAD_FILE(url, data);
};

// create a API endpoint for deleting certificates
export const deleteCertificateTemplate = (certificate_id) => {
  return DELETE(endpoint + `/certificate_template/${certificate_id}`);
};

export const editCertificate = (data) => {
  return POST(endpoint + `/edit_certificate`, data);
};
